import { UpdateAllergyPayload } from '../pages/allergies/create/types';
import apiClient from '../lib/apiClient';

export async function fetchAllergyList(patientId: number | undefined) {
  const response = await apiClient.get(`patients/${patientId}/show_allergies`);

  return response?.data?.data;
}

export async function updateAllergy(
  patientId: number | undefined,
  payload: UpdateAllergyPayload
) {
  const response = await apiClient.put(
    `patients/${patientId}/update_allergies`,
    payload
  );

  return response.data;
}
